module.exports = __webpack_public_path__ + "static/media/blank.8f6f48a7.jpg";